import { useMemo } from 'react'
import { isInNativeApp } from '../services/nativeBridge'

export const useIsNativeApp = () => {
  // 检查是否为原生应用
  const isNativeApp = useMemo(() => isInNativeApp(), [])
  return isNativeApp
}